module.exports = __webpack_public_path__ + "static/media/ge.49a0b418.svg";